import React from 'react'
import { Link } from 'react-router-dom'
import Constants from "../../Constants";

export default function Footer() {
  return (
    <footer className="footer">
            <div className="container">
                <p>Copyright &#169; {new Date().getFullYear()} OPAL-Marketing by Welocalize, Inc. All Rights Reserved. <Link to={Constants.PRIVACY_POLICY_LINK}>Privacy Policy</Link> | <Link to ={Constants.TERMS_LINK}>Terms of Use</Link></p>
            </div>
    </footer>
  )
}
